// Three Spirit market switcher. Added by Oleg @ IAKOE.
// Closes the <details> dropdown on outside click or Escape, and drops the
// ?ts_market=1 marker a switch from the other store left on this page's URL.

function dropMarketMarker() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('ts_market')) return;
  url.searchParams.delete('ts_market');
  history.replaceState(history.state, '', url.pathname + url.search + url.hash);
}
dropMarketMarker();

if (!customElements.get('ts-market-switcher')) {
  class TSMarketSwitcher extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      document.addEventListener('click', this.handleDocumentClick);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.details.open) return;
      if (!this.contains(event.target)) {
        this.details.open = false;
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.details.open = false;
      }
    }
  }

  customElements.define('ts-market-switcher', TSMarketSwitcher);
}
